var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column align-items-center"},[_c('img',{attrs:{"src":require("@/assets/images/doctor-online.png")}}),_c('span',{staticClass:"my-2"},[_vm._v(" "+_vm._s(_vm.message)+" ")]),_c('b-button',{attrs:{"variant":"primary"},on:{"click":_vm.goToSettings}},[_vm._v(" "+_vm._s(_vm.buttonTitle)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }